import React from 'react';
import Select from 'react-select';
import styled, { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';
import { Option } from 'types/types';

import { ErrorText } from 'styles/Styles.styled';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';
import { getEpdWizardCustomSelectStyles } from './wizard-select-styles';

type ErrorDisplayType = 'none' | 'text' | 'border' | 'text-and-border';

type TProps = Partial<TSmartLabelProps> & {
  name: string;
  value: any;
  options: any[];
  isMulti?: boolean;
  style?: any;
  onChanged: any;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
  errorDisplayType?: ErrorDisplayType;
};

const WizardSelectComponent: React.FunctionComponent<TProps> = ({
  label,
  options,
  tooltip,
  tooltipPosition,
  labelStyle,
  name,
  value,
  onChanged,
  disabled,
  style,
  placeholder,
  required,
  isMulti,
  isClearable = true,
  errorDisplayType = 'text',
  ...props
}) => {
  const theme = useTheme() as Theme;
  const customSelectStyles = getEpdWizardCustomSelectStyles(theme);

  const showErrorText = props.error && (errorDisplayType === 'text' || errorDisplayType === 'text-and-border');
  const showErrorBorder = props.error && (errorDisplayType === 'border' || errorDisplayType === 'text-and-border');

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
          hasValue={isMulti ? value && value.length > 0 : !!value?.value}
        />
      )}
      <StyledSelect
        options={options}
        name={name}
        defaultValue={value}
        onChange={(e: any) => {
          e !== value && onChanged(name, isMulti ? e?.map((x: Option) => x.value) : e?.value);
        }}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={disabled}
        styles={{
          ...customSelectStyles,
          control: (base: any, state: any) => ({
            ...customSelectStyles.control(base, state),
            ...(showErrorBorder && {
              borderColor: theme.colors.systemStatusError,
            }),
          }),
        }}
        placeholder={placeholder}
        {...props}
      />

      {showErrorText && <ErrorText style={{ fontSize: '10px', margin: 0 }}>{props.error}</ErrorText>}
    </div>
  );
};

const StyledSelect = styled(Select)``;

export default WizardSelectComponent;
